import React, { useState } from 'react'
import { connect } from 'react-redux'

// selectors
import { selectProjectId } from 'redux/project/selectors'
import { selectConfirmedSubscriptionPlan, selectIsLoadingSubscription } from 'redux/subscription/selectors'
import { selectIsFirstSession } from 'redux/user/selectors'

// components
import GlotioChatButton from 'components/GlotioComponents/GlotioChatButton'
import TicketSupportModalFullContent from '../TicketSupport/TicketSupportModal'

const GlotioTicket = ({ projectId, isFirstSession, hasSubscriptionPlan, isLoadingSubscription }) => {
  const [isOpenTicketForm, setIsOpenTicketForm] = useState(false)
  const isFirstAssistant = Boolean(projectId) && (isFirstSession || (!isLoadingSubscription && !hasSubscriptionPlan))

  if (isFirstAssistant) {
    return (
      <>
        {
          !isOpenTicketForm &&
          <GlotioChatButton
            onClick={() => setIsOpenTicketForm(true)}
            isOpenChat={isOpenTicketForm}
            unreadMessages={0}
            isLoading={false}
          />
        }
        <TicketSupportModalFullContent isOpen={isOpenTicketForm} handleClose={() => setIsOpenTicketForm(false)} />
      </>
    )
  }

  return null
}

const mapStateToProps = (state) => ({
  projectId: selectProjectId(state),
  isFirstSession: selectIsFirstSession(state),
  hasSubscriptionPlan: selectConfirmedSubscriptionPlan(state),
  isLoadingSubscription: selectIsLoadingSubscription(state)
})

export default connect(mapStateToProps, null)(GlotioTicket)
